import ToggleText from './ToggleText.vue'

export default ToggleText
